'use client';
import { Box, Typography, Container } from '@mui/material';
import Header from '../components/HomepageContent/Header';
import Footer from '../components/HomepageContent/Footer';
import KeyFeatures from '../components/HomepageContent/KeyFeatures';
import BrandName from '../components/BrandName';

const BRAND_BLUE = '#0F4C9C';

export default function Features() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa', display: 'flex', flexDirection: 'column' }}>
      <Header />

      {/* Simple Hero Section */}
      <Box sx={{ 
        background: `linear-gradient(135deg, ${BRAND_BLUE} 0%, #1E4A8C 50%, #2A5A9C 100%)`,
        py: { xs: 8, md: 10 }, 
        px: 4,
        textAlign: 'center',
        position: 'relative'
      }}>
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
          <Typography 
            variant="h1" 
            sx={{ 
              color: 'white', 
              fontWeight: 800,
              fontSize: { xs: '2rem', md: '3.25rem' },
              mb: 3
            }}
          >
            All Key Features
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              color: 'rgba(255,255,255,0.9)', 
              fontWeight: 300,
              lineHeight: 1.6,
              fontSize: { xs: '1.05rem', md: '1.25rem' }
            }}
          >
            Explore the comprehensive suite of tools <BrandName variant="dark" style={{ fontSize: 'inherit' }} /> offers to streamline operations, maintain compliance, and improve resident care.
          </Typography>
        </Container>
      </Box>

      {/* The 18 Key Features Component */}
      <Box sx={{ flexGrow: 1, py: 4, bgcolor: 'transparent' }}>
        <KeyFeatures />
      </Box>

      <Footer />
    </Box>
  );
}